export default "__VITE_ASSET__CA2kynUa__"